/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ShapeCircleMOffIcon20Solid = forwardRef('ShapeCircleMOffIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M2.796 2.204a1.125 1.125 0 0 0-1.591 1.591l2.721 2.722a7 7 0 0 0 9.556 9.556l2.723 2.723a1.125 1.125 0 0 0 1.59-1.591l-15-15Z" }),
        React.createElement("path", { d: "M17 10a6.971 6.971 0 0 1-.74 3.138L6.861 3.74A7 7 0 0 1 17 10Z" })));
});
